import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Option } from '../../types/commonElements';
import { FormData, UserState } from '../../types/userTypes';

const initialState: UserState = {
  formData: {
    name: "",
    role: "",
  // branch is multi-select; initialize as empty array to match Autocomplete multiple value expectation
  branch: [],
    phoneNumber: "",
    address: "",
    city: "",
    state: "",
    country: {
      label: "India",
      value: 1,
    },
    profilePhoto: null,
    email: "",
    password: "",
    registrationNo: "",
    countryCode: {
      label: "+91",
      value: "+91",
    },
    pinCode: "",
  },
  errors: {}, 
  selectOptions: {
    country: [],
    city: [],
    phoneNumber: [],
    state: [],
    role: [],
    branch: [],
  },
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setFormData: (state, action: PayloadAction<Partial<FormData>>) => {
      state.formData = { ...state.formData, ...action.payload };
    },
    setSelectOptions: (state, action: PayloadAction<{ [key: string]: Option[] }>) => {
      state.selectOptions = action.payload;
    },
    setErrors: (state, action: PayloadAction<Record<string, string>>) => {
      state.errors = action.payload;
    },
    clearErrors: (state) => {
      state.errors = {};
    },
    clearForm: (state) => {
      state.formData = initialState.formData;
      state.errors = {};
    },
  },
});

export const { setFormData, setErrors, clearErrors, clearForm, setSelectOptions } = userSlice.actions;

export default userSlice.reducer;
